import React, { memo } from "react";
import styled from "styled-components";
import { MinusIcon, PlusIcon } from "../../../components/Icons";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
`;

const QuantityWrapper = styled.div`
  text-align: center;
  display: grid;
  grid-template-columns: 15px 20px 15px;
  grid-gap: 17px;
`;

const QuantityDiv = styled.span`
  color: ${(props) => props.theme.quantityCartNumber};
`;

const ProductQuantity = ({ product, incrementItem, decrementItem }) => {
  return (
    <Wrapper>
      <QuantityWrapper>
        <div
          onClick={(ev) => {
            ev.preventDefault();
            if (product.flatProduct.quantity > 1) decrementItem();
          }}
        >
          <MinusIcon />
        </div>
        <QuantityDiv>{product.flatProduct.quantity}</QuantityDiv>
        <div
          onClick={(ev) => {
            ev.preventDefault();
            incrementItem();
          }}
        >
          <PlusIcon />
        </div>
      </QuantityWrapper>
    </Wrapper>
  );
};

export default ProductQuantity;
